<div class="main-container-edit">
    <mat-toolbar color="primary" >
        <div class="toolbar-title">
            <span>{{'translate.title'|translateTA}}</span>
        </div>
    </mat-toolbar>
    <mat-divider></mat-divider>
    <form [formGroup]="formGroup" class="form-container">
        <mat-form-field appearance="outline" ngClass="no-padding-form-field" *ngIf="!massChange">
            <mat-label>{{'translate.id.label'|translateTA}}</mat-label>
            <input matInput formControlName="ID" placeholder="{{'translate.id.placeholder'|translateTA}}">
            <mat-error *ngIf="formGroup.get('ID').hasError('required')">{{'translate.id.error.required'|translateTA}}</mat-error>
        </mat-form-field>
        
        <mat-form-field appearance="outline" ngClass="no-padding-form-field fill-container" *ngFor="let item of languages">
            <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" [name]="item.col" ></ngx-spinner>
            <mat-label>{{item.name}}</mat-label>
            <input matInput [formControlName]="item.col" [placeholder]="item.name">
            <mat-error *ngIf="formGroup.get(item.col).hasError('required')">{{item.name}} {{'translate.error.required'|translateTA}}</mat-error>
            <button mat-icon-button matSuffix *ngIf="item.col!='PTBR'"
                (click)="translateData($event,item)">
                <mat-icon>neurology</mat-icon>
            </button>
        </mat-form-field>

    </form>
    <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>